import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <section className="about-section-dark py-5" id="about">
      <div className="container">
        <div className="row align-items-center">
            {/* Left Content */}
            <div className="col-lg-6 mb-4 mb-lg-0 order-2 order-lg-1" data-aos="fade-right">

            <h2 className="fw-bold text-uppercase">
              <span className="lentotext">Nasha Mukti Kendra Mandi</span>
            </h2>
            <div className="about-divider"></div>
            <p className="text-light-custom text-start">
              <strong>Nasha Mukti Kendra Mandi </strong>is a trusted <strong>Rehabilitation Center in Mandi</strong> dedicated to helping individuals overcome addiction and reclaim their lives. With a team of experienced doctors, counselors, and therapists, we offer personalized recovery programs combining medical treatment, yoga, meditation, and counseling. Our peaceful Mandi facility provides a safe, supportive environment for holistic healing. We focus on not just recovery but also building<strong> confidence and a positive </strong>lifestyle. With <strong>24×7 support</strong>, family involvement, and a compassionate approach, we at <strong>Nasha Mukti Kendra</strong> stand by each person’s journey to <strong>lasting freedom from addiction</strong>.
              <br />
            </p>
            <a href="#contact" className="btn btn-primary mt-3 about-button">
              Contact Us
            </a>
          </div>

          {/* Right Image */}
          <div className="col-lg-6 col-md order-1 order-lg-2" data-aos="zoom-in">
            {/* <img src="/assets/800x600.jpg" alt="Lento India" className="img-fluid rounded shadow"/> */}
            {/* <img src="/assets/councelling.png" alt="Lento India" className="img-fluid rounded shadow"/> */}
            <img src="/assets/aboutimg.webp" alt="Nasha Mukti Mandi" className="about-img rounded shadow"/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
